import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { EndoMultiToothExamDataModel } from '../../../../models/forms/custom/mti/endo-multi-tooth-exam-data.model';
import { StaticDataService } from '../../../../services/static-data.service';
import { EnumValidValueItemModel } from '../../../../models/enum/enum-valid-value-item.model';
import { EndoMultiToothExamTeethInExamDataModel } from '../../../../models/forms/custom/mti/endo-multi-tooth-exam-teeth-in-exam-data.model';
import { EndoMultiToothExamToothDataModel } from '../../../../models/forms/custom/mti/endo-multi-tooth-exam-tooth-data.model';
import { MtiService } from '../../../../services/form/mti.service';
import { Globals } from '../../../../globals';
import { ToothService } from '../../../../services/tooth.service';
import { ToothConfigurationModel } from '../../../../models/teeth/tooth-configuration.model';
import { EndoMultiToothExamAutoFillConfigurationModel } from '../../../../models/forms/custom/mti/endo-multi-tooth-exam-auto-fill-configuration.model';
import { MtiTeethComponent } from './mti-teeth/mti-teeth.component';
import { DoctorsService } from '../../../../services/doctors.service';
import { DoctorQueryOptionsModel } from '../../../../models/doctors/doctor-query-options.model';
import { DoctorDataModel } from '../../../../models/doctors/doctor-data.model';
import { TdoDropdownChange } from '../../../../tdo-controls/common/tdo-dropdown-v2/models/tdo-dropdown-change';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { PainHistoryDialogComponent } from '../../../../dialog/pain-history-dialog/pain-history-dialog.component';
import { MtiPriorExamToothDialogComponent } from './dialog/mti-prior-exam-tooth-dialog/mti-prior-exam-tooth-dialog.component';
import { MtiPriorExamModel } from './dialog/mti-prior-exam-tooth-dialog/models/mti-prior-exam.model';
import { NotesService } from '../../../../services/notes.service';
import { TdoNoteAssociatedObject, TdoNoteSaveModel } from '../../../../main-interface/controls/tdo-notes/models/tdo-note-save-model';
import { MessagingService } from '../../../../services/messaging.service';
import { MessagingConstants } from '../../../../models/MessagingConstants';
import { TdoNoteQueryModel } from '../../../../main-interface/controls/tdo-notes/models/tdo-note-query.model';
import { MatSnackBar } from "@angular/material/snack-bar";
import { LocalStorageService } from "../../../../services/local-storage.service";
import { Subscription } from 'rxjs';
import { DialogService } from '../../../../services/dialog.service';
import { forEach } from 'cypress/types/lodash';

@Component({
  selector: 'app-mti',
  templateUrl: './mti.component.html',
  styleUrls: ['./mti.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MtiComponent implements OnInit, OnDestroy {
  @Input() currentCaseId: string;
  @Input() caseWorkItemFormsId: string;

  @ViewChild('mtiTeeth') mtiTeeth: MtiTeethComponent;

  isLoading = true;
  pendingOperations: number = 0;

  exams: EndoMultiToothExamDataModel[];
  selectedExam: EndoMultiToothExamDataModel;
  examAutofills: EndoMultiToothExamAutoFillConfigurationModel[] = [];
  doctors: DoctorDataModel[] = [];

  toothSurfaceEnums: EnumValidValueItemModel[] = [];
  toothCanalEnums: EnumValidValueItemModel[] = [];
  probingDepthEnums: EnumValidValueItemModel[] = [];

  examNamePredicate: (data: EndoMultiToothExamDataModel) => string;
  doctorNamePredicate: (data: DoctorDataModel) => string;

  cfgTeeth: ToothConfigurationModel[] = [];
  subscriptions: Subscription[] = [];

  constructor(private staticDataService: StaticDataService,
    private messagingService: MessagingService,
    private dialog: MatDialog,
    private cd: ChangeDetectorRef,
    private mtiService: MtiService,
    private globals: Globals,
    private notesService: NotesService,
    private doctorsService: DoctorsService,
    private toothService: ToothService,
    private localStorageService: LocalStorageService,
    private dialogService: DialogService,
    private snackbar: MatSnackBar) {
    if (staticDataService.isReady) {
      this.setupEnums();
    } else {
      this.staticDataService.validValuesReadyEvent.subscribe({
        complete: () => {
          this.setupEnums();
        }
      });
    }
  }

  ngOnInit(): void {
    this.doctorNamePredicate = (data: DoctorDataModel) => {
      return 'Dr. ' + data.dataContact.FirstName + ' ' + data.dataContact.LastName;
    };

    this.examNamePredicate = (data: EndoMultiToothExamDataModel) => {
      return new Date(data.xauditCreatedOn).toLocaleString();
    };

    this.mtiTeeth?.refreshExams.subscribe(() => {
      this.loadData(true);
    });

    const componentCall = this.messagingService.componentMessageCall.subscribe((response) => {
      //console.log("MtiComponent onInit this.messagingService.componentMessageCall.subscribe", response);
      switch (response.event) {
        case MessagingConstants.DOCTOR_UPDATE:
          if (this.selectedExam.ProviderDoctorID !== response.data.doctorId) {
            this.selectedExam.ProviderDoctorID = response.data.doctorId;
            this.cd.markForCheck();
            this.mtiService.saveExam(this.selectedExam).subscribe((res) => {
            });
          }
          break;
        case MessagingConstants.MTI_AUTOFILL_CHANGED:
          // autofill changed

          console.log("Autofill changed message received : Reload");
          this.mtiService.getExamAutoFills().subscribe((af) => {
            this.examAutofills = af;
          });
      }
    });


    this.subscriptions.push(componentCall);
  }

  private setupEnums() {
    // Load data
    this.toothSurfaceEnums = this.staticDataService.getValidValueItemsByValidValueName('enumToothSurface');
    this.toothCanalEnums = this.staticDataService.getValidValueItemsByValidValueName('enumToothCanal');
    this.probingDepthEnums = this.staticDataService.getValidValueItemsByValidValueName('enumProbingDepth');
    this.loadData();
  }

  private loadData(isJustExams = false) {
    this.mtiService.getExams(this.globals.currentPatientId).subscribe((res) => {
      this.exams = res;
      if (!isJustExams) {
        const OriginalMTIExam = this.exams.find(p => p.CaseWorkItemFormsId === this.caseWorkItemFormsId);
        this.selectedExam = (OriginalMTIExam !== null && OriginalMTIExam !== undefined) ? (OriginalMTIExam.OriMTEID !== null ? this.exams.find(p => p.MTEID === OriginalMTIExam.OriMTEID) : OriginalMTIExam) : OriginalMTIExam;

        if (this.selectedExam) {
          this.globals.currentMtiExamId = this.selectedExam.MTEID;
          const noteQueryModel = new TdoNoteQueryModel();
          noteQueryModel.parentObjectName = 'dataEndoMutiToothExam';
          noteQueryModel.objectId = this.selectedExam.MTEID;
          noteQueryModel.patientId = this.globals.currentPatientId;
          noteQueryModel.typeEnumId = '00000019-1000-0000-0000-000000000001';
          noteQueryModel.categoryEnumId = '00000018-1000-0000-0000-000000000005';
          this.notesService.changeNoteQuery(noteQueryModel);

          this.messagingService.sendComponentMessage(MessagingConstants.NOTES_REFRESH, '');
        }

        // Check if exam for today
        /*const todayExam = this.exams.find(p => {
          const today = new Date();
          const dt = new Date(p.xauditCreatedOn);
          if (dt.getDate() === today.getDate() && dt.getMonth() === today.getMonth() && dt.getFullYear() === today.getFullYear()) {
            return p;
          }
        });

        if (!todayExam) {
          this.onAddNewExamClick();
        }*/
        const currentExam = this.exams.find(p => p.CaseWorkItemFormsId?.toLowerCase() === this.caseWorkItemFormsId.toLowerCase());
        if (!currentExam) {
          this.onAddNewExamClick();
        }

        this.toothService.getAllTeeth(ToothService.enumUnitedStatesToothGrouping).subscribe((tres) => {
          this.cfgTeeth = tres;
          this.cd.markForCheck();
          this.isLoading = false;

          this.mtiService.getExamAutoFills().subscribe((af) => {
            this.examAutofills = af;
          });

          const docModel = new DoctorQueryOptionsModel();
          docModel.isLazyLoad = false;
          docModel.LOCID = parseInt(this.globals.LOCID);
          docModel.isIncludeReferring = false;
          docModel.isIncludeTdo = true;
          docModel.isActiveOnly = true;
          this.doctorsService.getDoctors(docModel).subscribe((docRes) => {
            this.doctors = docRes;
            if (this.selectedExam && !this.selectedExam.ProviderDoctorID) {
              const currentDoctor = this.doctors.find(p => p.DoctorId?.toLowerCase() === this.localStorageService?.practicingDoctorId?.toLowerCase());
              if (currentDoctor) {
                this.selectedExam.ProviderDoctorID = currentDoctor.DoctorId;
              }
            }
            this.cd.markForCheck();
          });
        });
      } else {
        //
        if (this.selectedExam) {
          this.selectedExam = this.exams.find(p => p.MTEID === this.selectedExam.MTEID);
        }
        this.cd.markForCheck();
        this.mtiTeeth.updateView();
      }
    });
  }

  onExamDateInputFinished(event: any) {
    this.selectedExam.Description = event;
    this.saveExam(this.selectedExam);
  }

  getToothNum(dataEndoMutiToothExamTooth: EndoMultiToothExamToothDataModel) {
    const tooth = this.cfgTeeth.find(p => p.ToothId.toLowerCase() === dataEndoMutiToothExamTooth.ToothId.toLowerCase());
    if (tooth) {
      return tooth.cfgToothDescriptions[0].Notation;
    }

    return '';
  }

  onAddNewExamClick() {
    const exam = new EndoMultiToothExamDataModel();
    exam.Description = new Date().toLocaleString();
    exam.PatientID = this.globals.currentPatientId;
    exam.CaseWorkItemFormsId = this.caseWorkItemFormsId;
    this.mtiService.saveExam(exam).subscribe((res) => {
      this.exams.unshift(res);
      this.selectedExam = res;
      this.globals.currentMtiExamId = this.selectedExam.MTEID;

      const noteQueryModel = new TdoNoteQueryModel();
      noteQueryModel.parentObjectName = 'dataEndoMutiToothExam';
      noteQueryModel.objectId = this.selectedExam.MTEID;
      noteQueryModel.patientId = this.globals.currentPatientId;
      noteQueryModel.typeEnumId = '00000019-1000-0000-0000-000000000001';
      noteQueryModel.categoryEnumId = '00000018-1000-0000-0000-000000000005';
      this.notesService.changeNoteQuery(noteQueryModel);
      this.messagingService.sendComponentMessage(MessagingConstants.NOTES_REFRESH, '');

      this.cd.markForCheck();
    });
  }

  saveExam(exam: EndoMultiToothExamDataModel) {
    this.mtiService.saveExam(exam).subscribe((res) => {
      const prior = this.exams.find(p => p.MTEID === res.MTEID);
      if (prior) {
        this.exams.unshift(res);
      }
      this.selectedExam = res;
      this.cd.markForCheck();
    });
  }

  onToothGroupSelected(event: EnumValidValueItemModel) {
    this.isLoading = true;
    this.pendingOperations = 0;
    this.selectedExam.dataEndoMutiToothExamTeethinExams.forEach(p => {
      this.pendingOperations++;
      this.mtiService.deleteTooth(p).subscribe((res) => {
        this.pendingOperations--;
      });
    });
    this.selectedExam.dataEndoMutiToothExamTeethinExams = [];
    const d = this.selectedExam.xauditCreatedOn.toString();
    this.selectedExam.Description = `${event.ItemDisplayValue} - ${this.getDate(d)}`;
    this.saveExam(this.selectedExam);
    const teethForLocation = this.cfgTeeth.filter(p => {
      const t = p.cfgToothLocations.find(e => e.enumToothLocationId === event.ValidValueItemId);
      if (t) {
        return p;
      }
    });

    let i = 0;
    for (const t of teethForLocation) {
      this.pendingOperations++;
      const tooth = new EndoMultiToothExamTeethInExamDataModel();
      tooth.ToothOrder = i++;
      tooth.MTEID = this.selectedExam.MTEID;
      const tt = new EndoMultiToothExamToothDataModel();
      tt.ToothId = t.ToothId;
      tooth.dataEndoMutiToothExamTooth = tt;
      this.saveTooth(tooth);
    }
  }

  saveTooth(tooth: EndoMultiToothExamTeethInExamDataModel) {
    this.mtiService.saveTooth(tooth).subscribe((res) => {
      //
      this.pendingOperations--;
      if (!this.selectedExam.dataEndoMutiToothExamTeethinExams.find(p => p.MTETiithInExanID === tooth.MTETiithInExanID)) {
        this.selectedExam.dataEndoMutiToothExamTeethinExams.push(res);
      }
      this.selectedExam.dataEndoMutiToothExamTeethinExams = this.selectedExam.dataEndoMutiToothExamTeethinExams.sort((a, b) => {
        return a.ToothOrder - b.ToothOrder;
      });
      setTimeout(() => {
        if (this.pendingOperations <= 0) 
          this.isLoading = false
        this.cd.markForCheck();
        this.mtiTeeth.updateView();
      }, 100);
    });
  }

  getDate(dateString: string) {
    const date = new Date(dateString);
    return date.toLocaleDateString();
  }

  onVitalClick() {
    let vitals = this.examAutofills.filter(p => p.isVital === true);
    vitals = vitals.sort((a, b) => {
      const d1 = new Date(a.xauditCreatedOn);
      const d2 = new Date(b.xauditCreatedOn);
      return d1.getTime() - d2.getTime();
    });

    if (vitals.length > 0) {
      for (const tooth of this.selectedExam.dataEndoMutiToothExamTeethinExams) {
        const t = tooth.dataEndoMutiToothExamTooth;
        const selection = vitals[0];
        t.enumMTEChiefComplaintID = selection.enumMTEChiefComplaintID;
        t.enumMTEPalpationID = selection.enumMTEPalpationID;
        t.enumMTEPercussionID = selection.enumMTEPercussionID;
        t.enumMTEMobilityID = selection.enumMTEMobilityID;
        t.enumMTEChewingID = selection.enumMTEChewingID;
        t.enumMTEBiteID = selection.enumMTEBiteID;
        t.enumMTEAirID = selection.enumMTEAirID;
        t.enumMTEColdID = selection.enumMTEColdID;
        t.enumMTEHotID = selection.enumMTEHotID;
        t.enumMTEeptID = selection.enumMTEeptID;
        t.enumMTESinusTrackID = selection.enumMTESinusTrackID;
        t.enumMTEOccusalTraumaID = selection.enumMTEOccusalTraumaID;
        t.enumMTEFractureID = selection.enumMTEFractureID;
        t.enumMTEPulpDiagID = selection.enumMTEPulpDiagID;
        t.enumMTEPerDiagID = selection.enumMTEPerDiagID;
        t.enumMTEEndoPrognosisID = selection.enumMTEEndoPrognosisID;
        t.enumMTEPerioPrognosisID = selection.enumMTEPerioPrognosisID;
        t.enumMTERestorPrognosisID = selection.enumMTERestorPrognosisID;
        t.enumMTERecomendedTxID = selection.enumMTERecomendedTxID;
        t.enumMTERecomendedTx_AfterID = selection.enumMTERecomendedTx_AfterID;
        t.enumMTERecomendedTx_ThirdID = selection.enumMTERecomendedTx_ThirdID;
        t.enumMTETretmentOrderID = selection.enumMTETretmentOrderID;
        t.enumMTENumberOfVisitsID = selection.enumMTENumberOfVisitsID;
        t.enumMTEVitalTestCavityID = selection.enumMTEVitalTestCavityID;
        t.enumMTESweetsID = selection.enumMTESweetsID;
        t.enumMTEFlossingID = selection.enumMTEFlossingID;
        t.enumMTELayingDownID = selection.enumMTELayingDownID;
        t.enumMTEExersiseBPID = selection.enumMTEExersiseBPID;
        t.enumMTEHeadPosistionID = selection.enumMTEHeadPosistionID;
        t.enumMTECervicalSensID = selection.enumMTECervicalSensID;
        t.enumMTEBLateralForceID = selection.enumMTEBLateralForceID;
        t.enumMTELLateralForceID = selection.enumMTELLateralForceID;
        this.saveTooth(tooth);
        this.mtiTeeth.updateView();
      }
    }
  }

  getDoctorById(selectedExam: EndoMultiToothExamDataModel) {
    if (!this.doctors || !this.selectedExam?.ProviderDoctorID) {
      return null;
    }
    const doc = this.doctors.find(p => p.DoctorId.toLowerCase() === selectedExam.ProviderDoctorID.toLowerCase());
    if (doc) {
      return doc;
    } else {
      return null;
    }
  }

  onDoctorChanged(event: TdoDropdownChange) {
    if (!this.selectedExam || !event.value) {
      return;
    }
    const doc = event.value as DoctorDataModel;
    this.selectedExam.ProviderDoctorID = doc.DoctorId;
    this.mtiService.saveExam(this.selectedExam).subscribe((res) => {
      //
    });
  }

  showPainHistory() {
    const config = new MatDialogConfig();
    config.panelClass = 'dialog';
    this.dialog.open(PainHistoryDialogComponent, config);
  }

  onAppendToothFromPriorExam() {
    const config = new MatDialogConfig();
    config.panelClass = 'dialog';
    config.data = { exams: this.exams.filter(p => p !== this.selectedExam), cfgTeeth: this.cfgTeeth };
    this.dialog.open(MtiPriorExamToothDialogComponent, config).afterClosed().subscribe((selections) => {
      if (selections) {
        const sel = selections as MtiPriorExamModel[];
        this.mtiService.associatePriorTeeth(this.selectedExam.MTEID, sel).subscribe(() => {
          this.loadData(true);
        });
      }
    });
  }

  saveAsNote() {
    let noteString = '';
    noteString += 'Exam: ' + this.selectedExam.Description + '\n\n';
    noteString += 'Teeth:\n';
    for (const t of this.selectedExam.dataEndoMutiToothExamTeethinExams) {
      const tooth = this.getTooth(t.dataEndoMutiToothExamTooth.ToothId);
      noteString += 'Tooth #: ' + tooth.cfgToothDescriptions[0].Notation + '\n';
      // @ts-ignore
      noteString += 'Date: ' + this.getDate(t.xauditCreatedOn as string) + '\n';
      if (t.dataEndoMutiToothExamTooth.enumMTEChiefComplaintID) { noteString += 'Chief Complaint: ' + this.getEnumDisplayName(t.dataEndoMutiToothExamTooth.enumMTEChiefComplaintID) + '\n'; }
      if (t.dataEndoMutiToothExamTooth.enumMTEPalpationID) { noteString += 'Palpitation: ' + this.getEnumDisplayName(t.dataEndoMutiToothExamTooth.enumMTEPalpationID) + '\n'; }
      if (t.dataEndoMutiToothExamTooth.enumMTEPercussionID) { noteString += 'Percussion: ' + this.getEnumDisplayName(t.dataEndoMutiToothExamTooth.enumMTEPercussionID) + '\n'; }
      if (t.dataEndoMutiToothExamTooth.enumMTEMobilityID) { noteString += 'Mobility: ' + this.getEnumDisplayName(t.dataEndoMutiToothExamTooth.enumMTEMobilityID) + '\n'; }
      if (t.dataEndoMutiToothExamTooth.enumMTEBiteID) { noteString += 'Bite: ' + this.getEnumDisplayName(t.dataEndoMutiToothExamTooth.enumMTEBiteID) + '\n'; }
      if (t.dataEndoMutiToothExamTooth.enumMTEChewingID) { noteString += 'Chewing: ' + this.getEnumDisplayName(t.dataEndoMutiToothExamTooth.enumMTEChewingID) + '\n'; }
      if (t.dataEndoMutiToothExamTooth.enumMTEAirID) { noteString += 'Air: ' + this.getEnumDisplayName(t.dataEndoMutiToothExamTooth.enumMTEAirID) + '\n'; }
      if (t.dataEndoMutiToothExamTooth.enumMTEColdID) { noteString += 'Cold: ' + this.getEnumDisplayName(t.dataEndoMutiToothExamTooth.enumMTEColdID) + '\n'; }
      if (t.dataEndoMutiToothExamTooth.enumMTEHotID) { noteString += 'Hot: ' + this.getEnumDisplayName(t.dataEndoMutiToothExamTooth.enumMTEHotID) + '\n'; }
      if (t.dataEndoMutiToothExamTooth.enumMTEeptID) { noteString += 'EPT: ' + this.getEnumDisplayName(t.dataEndoMutiToothExamTooth.enumMTEeptID) + '\n'; }
      if (t.dataEndoMutiToothExamTooth.enumMTESinusTrackID) { noteString += 'Sinus Track: ' + this.getEnumDisplayName(t.dataEndoMutiToothExamTooth.enumMTESinusTrackID) + '\n'; }
      if (t.dataEndoMutiToothExamTooth.enumMTEOccusalTraumaID) { noteString += 'Occusal Trauma: ' + this.getEnumDisplayName(t.dataEndoMutiToothExamTooth.enumMTEOccusalTraumaID) + '\n'; }
      if (t.dataEndoMutiToothExamTooth.enumMTEFractureID) { noteString += 'Fracture: ' + this.getEnumDisplayName(t.dataEndoMutiToothExamTooth.enumMTEFractureID) + '\n'; }
      if (t.dataEndoMutiToothExamTooth.enumMTEPulpDiagID) { noteString += 'Pulp Diag: ' + this.getEnumDisplayName(t.dataEndoMutiToothExamTooth.enumMTEPulpDiagID) + '\n'; }
      if (t.dataEndoMutiToothExamTooth.enumMTEPerDiagID) { noteString += 'Periapical Diag: ' + this.getEnumDisplayName(t.dataEndoMutiToothExamTooth.enumMTEPerDiagID) + '\n'; }
      if (t.dataEndoMutiToothExamTooth.enumMTEEndoPrognosisID) { noteString += 'Endo Prognosis: ' + this.getEnumDisplayName(t.dataEndoMutiToothExamTooth.enumMTEEndoPrognosisID) + '\n'; }
      if (t.dataEndoMutiToothExamTooth.enumMTEPerioPrognosisID) { noteString += 'Perio Prognosis: ' + this.getEnumDisplayName(t.dataEndoMutiToothExamTooth.enumMTEPerioPrognosisID) + '\n'; }
      if (t.dataEndoMutiToothExamTooth.enumMTERestorPrognosisID) { noteString += 'Restorative Prognosis: ' + this.getEnumDisplayName(t.dataEndoMutiToothExamTooth.enumMTERestorPrognosisID) + '\n'; }
      if (t.dataEndoMutiToothExamTooth.enumMTERecomendedTxID) { noteString += 'Recommended Tx: ' + this.getEnumDisplayName(t.dataEndoMutiToothExamTooth.enumMTERecomendedTxID) + '\n'; }
      if (t.dataEndoMutiToothExamTooth.enumMTERecomendedTx_AfterID) { noteString += 'After Recommended Tx: ' + this.getEnumDisplayName(t.dataEndoMutiToothExamTooth.enumMTERecomendedTx_AfterID) + '\n'; }
      if (t.dataEndoMutiToothExamTooth.enumMTERecomendedTx_ThirdID) { noteString += '3rd Recommended Tx: ' + this.getEnumDisplayName(t.dataEndoMutiToothExamTooth.enumMTERecomendedTx_ThirdID) + '\n'; }
      if (t.dataEndoMutiToothExamTooth.enumMTETretmentOrderID) { noteString += 'Treatment Order: ' + this.getEnumDisplayName(t.dataEndoMutiToothExamTooth.enumMTETretmentOrderID) + '\n'; }
      if (t.dataEndoMutiToothExamTooth.enumMTENumberOfVisitsID) { noteString += 'Estimated # of Visits: ' + this.getEnumDisplayName(t.dataEndoMutiToothExamTooth.enumMTENumberOfVisitsID) + '\n'; }

      if (t.dataEndoMutiToothExamTooth.enumMTEVitalTestCavityID) { noteString += 'Vital Test Cavity: ' + this.getEnumDisplayName(t.dataEndoMutiToothExamTooth.enumMTEVitalTestCavityID) + '\n'; }
      if (t.dataEndoMutiToothExamTooth.enumMTESweetsID) { noteString += 'Sweets: ' + this.getEnumDisplayName(t.dataEndoMutiToothExamTooth.enumMTESweetsID) + '\n'; }
      if (t.dataEndoMutiToothExamTooth.enumMTEFlossingID) { noteString += 'Flossing: ' + this.getEnumDisplayName(t.dataEndoMutiToothExamTooth.enumMTEFlossingID) + '\n'; }
      if (t.dataEndoMutiToothExamTooth.enumMTELayingDownID) { noteString += 'Lying Down: ' + this.getEnumDisplayName(t.dataEndoMutiToothExamTooth.enumMTELayingDownID) + '\n'; }
      if (t.dataEndoMutiToothExamTooth.enumMTEExersiseBPID) { noteString += 'Excercise BP: ' + this.getEnumDisplayName(t.dataEndoMutiToothExamTooth.enumMTEExersiseBPID) + '\n'; }
      if (t.dataEndoMutiToothExamTooth.enumMTEHeadPosistionID) { noteString += 'Head Position: ' + this.getEnumDisplayName(t.dataEndoMutiToothExamTooth.enumMTEHeadPosistionID) + '\n'; }
      if (t.dataEndoMutiToothExamTooth.enumMTECervicalSensID) { noteString += 'Cervical Sensitivity: ' + this.getEnumDisplayName(t.dataEndoMutiToothExamTooth.enumMTECervicalSensID) + '\n'; }
      if (t.dataEndoMutiToothExamTooth.enumMTEBLateralForceID) { noteString += 'B Lateral Force: ' + this.getEnumDisplayName(t.dataEndoMutiToothExamTooth.enumMTEBLateralForceID) + '\n'; }
      if (t.dataEndoMutiToothExamTooth.enumMTELLateralForceID) { noteString += 'L Lateral Force: ' + this.getEnumDisplayName(t.dataEndoMutiToothExamTooth.enumMTELLateralForceID) + '\n'; }

      // Caries and Pulp here
      noteString += '\n';
      if (t.dataEndoMutiToothExamTooth.isCavity) {
        noteString += 'Cavity present:\n';
        noteString += 'Surfaces:\n';
        for (const carie of t.dataEndoMutiToothExamTooth.dataEndoMutiToothExamTeethCavities) {
          noteString += this.getToothSurfaceName(carie.ToothSurfaceId) + '\n';
        }
      }

      noteString += 'Canal Probing Depth: \n';
      for (const canal of t.dataEndoMutiToothExamTooth.dataEndoMutiToothExamSurfaces) {
        noteString += this.getToothSurfaceName(canal.ToothSurfaceId) + ': ' + this.getEnumDisplayName(canal.enumProbingDepthID) + '\n';
      }

      noteString += '\n';
    }


    /*const noteQueryModel = new TdoNoteQueryModel();
    noteQueryModel.parentObjectName = 'dataEndoMutiToothExam';
    noteQueryModel.objectId = this.selectedExam.MTEID;
    noteQueryModel.patientId = this.globals.currentPatient;
    this.notesService.changeNoteQuery(noteQueryModel);*/

    const noteModel = new TdoNoteSaveModel();
    noteModel.associatedObjects = [];
    const as1 = new TdoNoteAssociatedObject();
    as1.parentObjectName = 'dataEndoMutiToothExam';
    as1.objectId = this.selectedExam.MTEID;
    noteModel.associatedObjects.push(as1);
    noteModel.text = noteString;
    noteModel.patientId = this.globals.currentPatientId;
    noteModel.categoryEnumIds = ['00000018-1000-0000-0000-000000000010'];
    noteModel.typeEnumIds = ['00000019-1000-0000-0000-000000000001', '00000019-1000-0000-0000-000000000002'];
    this.notesService.saveNote(noteModel).subscribe((res) => {
      this.messagingService.sendComponentMessage(MessagingConstants.NOTES_REFRESH, '');
    });
  }

  private getToothSurfaceName(surfaceId: string) {
    const tt = this.cfgTeeth.find(p => p.cfgToothSurfaces.find(e => e.ToothSurfaceId === surfaceId));
    if (tt) {
      return tt.Name;
    }

    return '';
  }

  private getTooth(ToothId: string) {
    return this.cfgTeeth.find(p => p.ToothId === ToothId);
  }

  private getEnumDisplayName(vvid: string) {
    const vvi = this.staticDataService.getValidValueItemsByItemIds([vvid])[0];
    if (vvi) {
      return vvi.ItemDisplayValue;
    } else {
      return '';
    }
  }

  onExamChange() {
    this.globals.currentMtiExamId = this.selectedExam.MTEID;

    const noteQueryModel = new TdoNoteQueryModel();
    noteQueryModel.parentObjectName = 'dataEndoMutiToothExam';
    noteQueryModel.objectId = this.selectedExam.MTEID;
    noteQueryModel.patientId = this.globals.currentPatientId;
    noteQueryModel.typeEnumId = '00000019-1000-0000-0000-000000000001';
    noteQueryModel.categoryEnumId = '00000018-1000-0000-0000-000000000005';
    this.notesService.changeNoteQuery(noteQueryModel);
    //this.messagingService.sendComponentMessage(MessagingConstants.NOTES_REFRESH, '');
  }

  deleteMti() {
    this.mtiService.deleteExam(this.selectedExam).subscribe((res) => {
      const idx = this.exams.findIndex(p => p.MTEID === this.selectedExam.MTEID);
      this.snackbar.open('Delete success', '', { duration: 3000 });
      if (idx > -1) {
        this.exams.splice(idx, 1);
        if (this.exams.length > 0) {
          this.selectedExam = this.exams[0];
        } else {
          this.selectedExam = null;
        }
        this.cd.markForCheck();
      }
    });
  }

  associateToForm() {
    this.mtiService.associateToForm(this.caseWorkItemFormsId, this.selectedExam.MTEID).subscribe((res) => {

    });
  }



  downloadAll() {
    var msg = '';
    var downloaded = 0;
    console.log(this.selectedExam.dataEndoMutiToothExamTeethinExams);
    this.selectedExam.dataEndoMutiToothExamTeethinExams.forEach(component => {
      if (component.dataEndoMutiToothExamTooth.isToothDownloaded === true) {
        msg += this.getToothNum(component.dataEndoMutiToothExamTooth) + ',';
        downloaded++;
      }
    });
    if (downloaded > 0) {
      msg = msg.substring(0, msg.length - 1);
      if (downloaded == this.selectedExam.dataEndoMutiToothExamTeethinExams.length) {
        this.dialogService.openConfirmDialog('All the teeth for this form were already downloaded.', false, false, 'Alert').subscribe((res) => {

        });
      }
      else {
        this.dialogService.openConfirmDialog('The following teeth were already downloaded: ' + msg + '. do you want to continue downloading the rest?', false, true, 'Alert').subscribe((res) => {
          if (res) {
            //if user accepts to continue remove the downloaded teeth and send the arra to the backend to process
            localStorage.setItem('isSelectedMTI', 'true');
            let selectedExam: EndoMultiToothExamTeethInExamDataModel[] = [];
            selectedExam.push(...this.selectedExam.dataEndoMutiToothExamTeethinExams.filter(item => item.dataEndoMutiToothExamTooth.isToothDownloaded != true));
            this.mtiService.downloadTeeth(selectedExam, this.globals.currentPatientCaseWorkItemID).subscribe((res) => {
              //this.messagingService.sendComponentMessage(MessagingConstants.CASE_FORMS_REFRESH, {});
              this.selectedExam.dataEndoMutiToothExamTeethinExams.map(p => p.dataEndoMutiToothExamTooth.isToothDownloaded = true);
              this.messagingService.sendComponentMessage(MessagingConstants.CASES_REFRESH, res);
            });
            this.cd.markForCheck();
          }
        });
      }
    } else {
      localStorage.setItem('isSelectedMTI', 'true');
      this.selectedExam.dataEndoMutiToothExamTeethinExams.map(p => p.dataEndoMutiToothExamTooth.isToothDownloaded = true);
      this.mtiService.downloadTeeth(this.selectedExam.dataEndoMutiToothExamTeethinExams, this.globals.currentPatientCaseWorkItemID).subscribe((res) => {
        //this.messagingService.sendComponentMessage(MessagingConstants.CASE_FORMS_REFRESH, {});
        this.messagingService.sendComponentMessage(MessagingConstants.CASES_REFRESH, res);
      });
      this.cd.markForCheck();
    }


  }

  ngOnDestroy(): void {
    for (const sub of this.subscriptions) {
      if (sub)
        sub.unsubscribe();
    }
  }
}
